import { notify } from '@billy/design-system'
import { TFunction } from 'i18next'

import { NotificationKeys } from '../../../../../enums/notificationKeys'

export const notifySyncStartError = (t: TFunction) =>
  notify({
    id: NotificationKeys.ExternalInvoicesSyncStarted,
    message: t('external_invoices_sync_modal.sync_error'),
    variant: 'error',
  })
